export default "https://cdn-static.gokick.com/assets/9d5d62c9c10b295872f7f6ffd14ff177054c61a9/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";